import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend, setInteractionMode } from 'vee-validate';
import { required, email, ext, integer, image, confirmed } from 'vee-validate/dist/rules';
setInteractionMode('lazy');

extend('required', {
    ...required,
    message: 'This field is required.'
});

extend('confirmed', {
    ...confirmed,
    message: 'The fields do not match.'
});


extend('email', {
    ...email,
    message: 'This must be a valid email address.'
});

extend('integer', {
    ...integer,
    message: 'This must be a positive integer.'
});

extend('image', {
    ...image,
    message: 'A valid jpg, jpeg or png image is required.'
});

extend('ext', {
    ...ext,
    message: 'A valid jpg, jpeg, png or .pdf file is required.'
});

extend('url', {
    validate(value) {
        if (value) {
            // eslint-disable-next-line no-useless-escape
            return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
        }

        return false;
    },
    message: 'A valid URL is required.'
});

extend('min', {
    validate(value, args) {
        if (value.length >= args.length) {
            return true;
        }
        return 'Minimum ' + args.length + ' characters.';
    },
    params: ['length']
});

extend('max', {
    validate(value, args) {
        if (value.length <= args.length) {
            return true;
        }
        return 'Maximum ' + args.length + ' characters.';
    },
    params: ['length']
});

// Register Validator globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
